import React, { useRef } from 'react';

import SearchIcon from '../../assets/Svg/SearchIcon';
import CrossIcon from '../../assets/Svg/CrossIcon';
import { COLORS } from '../../utils/constants/colors';
import { CLEAR_SEARCH_LABEL, CLEAR_ICON_SIZE, SEARCH_PLACEHOLDER } from './constants';
import { PropertySearchInputProps } from './types';

import styles from './PropertySearchInput.module.scss';

const PropertySearchInput: React.FC<PropertySearchInputProps> = ({ value, onChange }) => {
    const inputRef = useRef<HTMLInputElement>(null);

    // SideDrawer closes on a document-level Escape; with text in the box Escape only clears it.
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key !== 'Escape' || !value) return;
        e.preventDefault();
        e.stopPropagation();
        onChange('');
    };

    const handleClear = () => {
        onChange('');
        inputRef.current?.focus();
    };

    return (
        <div className={styles.SearchWrapper}>
            <input
                ref={inputRef}
                type="search"
                className={styles.SearchInput}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder={SEARCH_PLACEHOLDER}
                aria-label={SEARCH_PLACEHOLDER}
                autoComplete="off"
            />
            {value ? (
                <button type="button" className={styles.ClearButton} aria-label={CLEAR_SEARCH_LABEL} onClick={handleClear}>
                    <CrossIcon colour={COLORS.LIGHT_GREY} width={CLEAR_ICON_SIZE} height={CLEAR_ICON_SIZE} />
                </button>
            ) : (
                <SearchIcon aria-hidden="true" className={styles.SearchIcon} stroke={COLORS.LIGHT_GREY} />
            )}
        </div>
    );
};

export default PropertySearchInput;
